module.exports = __webpack_public_path__ + "img/1543773220.9fe3da29.jpg";